import React from 'react';
import PropTypes from 'prop-types';

const CreditCard = ({ fill = '#434343' }) => (
  <svg
    width="20px"
    viewBox="0 0 24 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Card"
        transform="translate(-6.000000, -10.000000)"
        fill={fill}
        fillRule="nonzero"
      >
        <g transform="translate(6.000000, 10.000000)" id="credit-card">
          <g>
            <path
              d="M21.4581053,0.0155789474 L2.49511111,0.0155789474 C1.11981287,0.0155789474 0,1.13539181 0,2.51073684 L0,13.4893099 C0,14.8646082 1.11981287,15.9844211 2.49511111,15.9844211 L21.4580585,15.9844211 C22.8333567,15.9844211 23.9531696,14.8646082 23.9531696,13.4893099 L23.9531696,2.51073684 C23.9531696,1.13539181 22.8334035,0.0155789474 21.4581053,0.0155789474 Z M22.9551813,13.4892632 C22.9551813,14.3146667 22.2835088,14.9863392 21.4581053,14.9863392 L2.49511111,14.9863392 C1.6697076,14.9863392 0.998035088,14.3146667 0.998035088,13.4892632 L0.998035088,2.51073684 C0.998035088,1.68533333 1.6697076,1.01366082 2.49511111,1.01366082 L21.4580585,1.01366082 C22.283462,1.01366082 22.9551813,1.68533333 22.9551813,2.51073684 L22.9551813,13.4892632 L22.9551813,13.4892632 Z"
              id="Shape"
            />
            <path
              d="M23.4999385,3 L0.500014648,3 C0.224015187,3 0,3.16801041 0,3.37500879 L0,5.62499121 C0,5.83198959 0.224015187,6 0.500014648,6 L23.4999854,6 C23.7759848,6 24,5.83198959 24,5.62499121 L24,3.37500879 C24,3.16801041 23.7759379,3 23.4999385,3 Z"
              id="Shape"
            />
            <path
              d="M9.48734503,8 L3.49904094,8 C3.22357895,8 3,8.22357895 3,8.49904094 C3,8.77450292 3.22357895,8.99803509 3.49904094,8.99803509 L9.48734503,8.99803509 C9.76280702,8.99803509 9.98638596,8.77445614 9.98638596,8.49899415 C9.98638596,8.22353216 9.76280702,8 9.48734503,8 Z"
              id="Path"
            />
            <path
              d="M9.48149708,10.9921871 L3.49319298,10.9921871 C3.21773099,10.9921871 2.99415205,11.2157661 2.99415205,11.4912281 C2.99415205,11.7666901 3.21773099,11.990269 3.49319298,11.990269 L9.48149708,11.990269 C9.75695906,11.990269 9.98053801,11.7666901 9.98053801,11.4912281 C9.98053801,11.2157661 9.75695906,10.9921871 9.48149708,10.9921871 Z"
              id="Path"
            />
            <path
              d="M19.4951111,8 L18.497076,8 C17.6716725,8 17,8.67167251 17,9.49707602 L17,10.4951111 C17,11.3205146 17.6716725,11.9921871 18.497076,11.9921871 L19.4951111,11.9921871 C20.3205146,11.9921871 20.9921871,11.3205146 20.9921871,10.4951111 L20.9921871,9.49707602 C20.9921871,8.6717193 20.3205146,8 19.4951111,8 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

CreditCard.propTypes = {
  fill: PropTypes.string,
};

export default CreditCard;
